module.exports = __webpack_public_path__ + "static/media/8.9cdc7db6.gif";